import {
  Component,
  EventEmitter,
  Injector,
  Input,
  OnInit,
  Output,
  forwardRef,
} from '@angular/core';
import {
  AbstractControl,
  ControlValueAccessor,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  NgControl,
  ValidationErrors,
  Validator,
} from '@angular/forms';
import { RRITimeFieldInput } from '../../interfaces/time-field-input.interface';

@Component({
  selector: 'rr-time-field',
  templateUrl: './time-field.component.html',
  styleUrls: ['./time-field.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TimeFieldComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => TimeFieldComponent),
      multi: true,
    },
  ],
})
export class TimeFieldComponent
  implements OnInit, ControlValueAccessor, Validator
{
  public data: Date;
  public onChangeFn: any = (_: any) => Date;
  public onTouchFn: any = () => {};
  public control: NgControl;
  private errorMessages = new Map<string, () => string>();

  // @Output() dataChange: EventEmitter<Date> = new EventEmitter<Date>();
  @Input() settings: RRITimeFieldInput;
  @Input() disabled: boolean = false;
  @Input() required: boolean = false;
  @Input() customErrorMessages: Map<string, () => string>;
  // TODO
  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onDateChange: EventEmitter<Date> = new EventEmitter();
  @Output() clearInput: EventEmitter<Date> = new EventEmitter();

  constructor(private inj: Injector) {
    this.errorMessages.set('required', () => `Timefield is required.`);
  }

  ngOnInit(): void {
    this.control = this.inj.get(NgControl, null);
    if (this.customErrorMessages && this.customErrorMessages.size) {
      this.errorMessages = new Map([
        ...Array.from(this.errorMessages.entries()),
        ...Array.from(this.customErrorMessages.entries()),
      ]);
    }

    this.onChangeFn(this.data);
  }

  public onClearInput(): void {
    if (!this.settings.disableClearEvent) {
      if (this.settings.defaultValue) {
        this.data = this.settings.defaultValue;
      } else {
        this.data = void 0;
      }
    }
    this.clearInput.emit(this.data);
  }

  public writeValue(newDate: Date): void {
    this.data = newDate;
  }

  public registerOnChange(fn: Date): void {
    this.onChangeFn = fn;
  }

  public registerOnTouched(fn: () => void): void {
    this.onTouchFn = fn;
  }

  public setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
  public onChange() {
    this.onChangeFn(this.data);
  }

  public get invalid(): boolean {
    return this.control ? this.control.invalid : false;
  }

  public get showError(): boolean {
    if (!this.control) {
      return false;
    }

    const { dirty, touched, value } = this.control;

    return this.invalid ? dirty || touched || !!value : false;
  }

  public get errors(): Array<string> {
    if (!this.control) {
      return [];
    }

    const { errors } = this.control;
    return Object.keys(errors).map((key) => {
      return this.errorMessages.has(key)
        ? this.errorMessages.get(key)()
        : 'error: ' + key;
    });
  }
  public validate(_control: AbstractControl): ValidationErrors | null {
    return null;
  }
}
